import Vue from "vue";
import * as MutationsType from "./mutationsType";

export default {
  [MutationsType.SET_BUSINESS](state, payload) {
    state.business = payload;
  },
  [MutationsType.UPDATE_BUSINESS](state, payload) {
    state.business = { ...state.business, ...payload };
  },
  [MutationsType.SET_LANDING_PAGE](state, payload) {
    state.landingPage = payload;
  },
  [MutationsType.SET_LANDING_PAGES](state, payload) {
    state.landingPages = payload;
  },
  [MutationsType.ADD_LANDING_PAGE](state, payload) {
    if (state.landingPages) state.landingPages.push(payload);
  },
  [MutationsType.UPDATE_LANDING_PAGE](state, payload) {
    if (state.landingPages) {
      let ind = state.landingPages.findIndex((landingPage) => landingPage.id === payload.id);
      if (ind >= 0) Vue.set(state.landingPages, ind, { ...state.landingPages[ind], ...payload });
    }
  },
  [MutationsType.SET_ECOMMERCE](state, payload) {
    state.ecommerce = payload;
  },
  [MutationsType.SET_EMBED_FORM](state, payload) {
    state.embedForm = payload;
  },
  [MutationsType.SET_EMBED_FORMS](state, payload) {
    state.embedForms = payload;
  },
  [MutationsType.ADD_EMBED_FORM](state, payload) {
    state.embedForms.unshift(payload);
  },
  [MutationsType.UPDATE_EMBED_FORM](state, payload) {
    let ind = (state.embedForms || []).findIndex((embedForm) => embedForm.id === payload.id);
    if (ind >= 0) Vue.set(state.embedForms, ind, { ...state.embedForms[ind], ...payload });

    if (state.embedForm && state.embedForm.id === payload.id) state.embedForm = { ...state.embedForm, ...payload };
  },

  [MutationsType.SET_CUSTOM_FORM](state, payload) {
    state.customForm = payload;
  },
  [MutationsType.SET_CUSTOM_FORMS](state, payload) {
    state.customForms = payload;
  },
  [MutationsType.ADD_CUSTOM_FORM](state, payload) {
    state.customForms.unshift(payload);
  },
  [MutationsType.UPDATE_CUSTOM_FORM](state, payload) {
    let ind = (state.customForms || []).findIndex((customForm) => customForm.id === payload.id);
    if (ind >= 0) Vue.set(state.customForms, ind, { ...state.customForms[ind], ...payload });

    if (state.customForm && state.customForm.id === payload.id) state.customForm = { ...state.customForm, ...payload };
  },
  [MutationsType.SET_SPECIAL_FIELDS](state, payload) {
    state.specialFields = payload;
  },
  [MutationsType.ADD_SPECIAL_FIELD](state, payload) {
    state.specialFields.unshift(payload);
  },
  [MutationsType.UPDATE_SPECIAL_FIELD](state, payload) {
    let ind = (state.specialFields || []).findIndex((specialField) => specialField.id === payload.id);
    if (ind >= 0) Vue.set(state.specialFields, ind, { ...state.specialFields[ind], ...payload });
  },
  [MutationsType.SET_FAQ](state, payload) {
    state.faq = payload;
  },
  [MutationsType.SET_FAQS](state, payload) {
    state.faqs = payload;
  },
  [MutationsType.ADD_FAQ](state, payload) {
    state.faqs.unshift(payload);
  },
  [MutationsType.UPDATE_FAQ](state, payload) {
    let ind = (state.faqs || []).findIndex((faq) => faq.id === payload.id);
    if (ind >= 0) Vue.set(state.faqs, ind, { ...state.faqs[ind], ...payload });
  },
  [MutationsType.DELETE_FAQ](state, payload) {
    let ind = state.faqs.findIndex((faq) => faq.id === payload.id);
    if (ind >= 0) Vue.delete(state.faqs, ind);
  },
};
